<template>
    <v-card v-if="myData != null" flat>
        <v-card-text v-if='localFeedback'>
            {{localFeedback}}
        </v-card-text>
        <v-card-text v-if='!localFeedback'>             
            <v-row v-for="prax, index in myData.praxe" :key="index" align="center" v-bind:id="prax.id">
                <v-card variant="outlined" style="width:100%;margin-top:-1px;background-color:#E8F5E9">
                    <v-card-text>
                        <v-row style="margin:5px" align ="center">
                            <v-card flat style="background-color:#E8F5E9">
                                <h4>{{prax.student}} - {{prax.firma}} ({{prax.mesto}})</h4>
                                <p><b>činnosti: </b>{{prax.napln_praxe}}</p>
                            </v-card>                            
                            <v-spacer />
                            <v-rating color="green" length="5" v-model="prax.hodnotenie"
                                    readonly half-increments size="compact" style="scale:1" />
                            <v-btn size="x-small" variant="outlined" @click="showDetail1(prax.id, index)">Info</v-btn>                                                                                        
                        </v-row>
                    </v-card-text>
                    <v-card-text v-if="showpraxIndex == index" style="background-color:white">
                        <v-row style="margin:5px">
                            <b>Hodnotenie učiteľmi ({{praxData.pocet_ucitel}}):</b>
                            <v-spacer />
                            <v-icon @click="closeprax(prax.id)">close</v-icon>
                        </v-row>
                    <v-card variant="outlined" v-for="otazka,index2 in praxData.hodnotenia_ucitel" :key="index2" style="margin:2px">
                        <v-card-text>
                            <v-row style="margin:2px" align="center">
                                {{otazka.otazka}}
                                <v-spacer />
                                <v-rating color="green" length="5" v-model="otazka.hodnotenie"
                                    readonly half-increments size="compact" style="scale:1" />
                                <v-btn size="x-small" variant="outlined" @click="showDetail2(otazka.otazka_id,'t', prax.id, index2)">Detail</v-btn>                                                            
                            </v-row>
                            <v-card-text v-if="showDetailIndex == 't'+index2 && myDetail" style="margin:5px">
                                <v-row v-for="hodnotenie, index3 in myDetail.hodnotenia" :key="index3" align="center">
                                    <v-col cols=12> 
                                        <v-row align="center">
                                            {{hodnotenie.pocet}} x 
                                            <v-rating color="green" length="5" v-model="hodnotenie.otazka_hodnota"
                                                readonly half-increments size="compact" style="scale:0.75" />
                                        </v-row>
                                        <v-row v-for="komentar, index4 in myDetail.komentare" :key="index4">
                                            <p v-if="komentar.otazka_hodnota == hodnotenie.otazka_hodnota" style="margin-left:10px">
                                                - {{komentar.otazka_text}} 
                                            </p>
                                    </v-row>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-card-text>
                    </v-card>
                    </v-card-text>
                    <v-card-text style="background-color:white" v-if="showpraxIndex == index">
                    <b>Hodnotenie študentami ({{praxData.pocet_student}}): </b>
                    <v-card variant="outlined" v-for="otazka,index2 in praxData.hodnotenia_student" :key="index2" style="margin:2px">
                        <v-card-text>
                            <v-row style="margin:2px">
                                {{otazka.otazka}}
                                <v-spacer />
                                <v-rating color="green" length="5" v-model="otazka.hodnotenie"
                                    readonly half-increments size="compact" style="scale:1" />
                                <v-btn size="x-small" variant="outlined" @click="showDetail2(otazka.otazka_id,'s', prax.id, index2)">Detail</v-btn>                                                            
                            </v-row>
                            <v-card-text v-if="showDetailIndex == 's'+index2 && myDetail" style="margin:5px">
                                <v-row v-for="hodnotenie, index3 in myDetail.hodnotenia" :key="index3" align="center">
                                    <v-col cols=12> 
                                        <v-row align="center">
                                            {{hodnotenie.pocet}} x 
                                            <v-rating color="green" length="5" v-model="hodnotenie.otazka_hodnota"
                                                readonly half-increments size="compact" style="scale:0.75" />
                                        </v-row>
                                        <v-row v-for="komentar, index4 in myDetail.komentare" :key="index4">
                                            <p v-if="komentar.otazka_hodnota == hodnotenie.otazka_hodnota" style="margin-left:10px">
                                                - {{komentar.otazka_text}} 
                                            </p>
                                    </v-row>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-card-text>
                    </v-card>
                    <v-row style="margin-top:5px">
                        <v-spacer />
                        <v-icon @click="closeprax(prax.id)">close</v-icon>
                    </v-row>
                    </v-card-text>
                </v-card>
            </v-row>
        </v-card-text>
    </v-card>
</template>

<script>
import axios from '../../axios-auth.js'

export default {
    data() {
        return {
            myData : null,
            myDetail: null,
            localFeedback: '',
            showpraxIndex: -1,
            showDetailIndex: -1
        }
    },
    mounted() {
        this.initData()
    },
    methods : {
        initData() {
            axios.get('/get-practices-all-results', this.$store.getters.getAxiosConfig)
            .then((res) => {
                this.myData = res.data   
                if (res.data.message != 'OK') {
                    this.localFeedback = res.data.message
                } 
            })
            .catch(error => {
                this.$store.commit('setFeedback', error.name+': '+error.message)
            })
        },
        showDetail1(_prax_id, _index) {
            const _data = {
                prax_id : _prax_id
            }
            axios.post('/get-practices-detail1', _data, this.$store.getters.getAxiosConfig)
            .then((res) => {
                this.praxData = res.data  
                // console.log(res.data) 
                if (res.data.message != 'OK') {
                    this.localFeedback = res.data.message
                } 
                this.showpraxIndex = _index
                this.gototo(_prax_id)
            })
            .catch(error => {
                this.$store.commit('setFeedback', error.name+': '+error.message)
            })
        },
        showDetail2(_otazka_id,_user_type, _prax_id, _index) {
            const data = {
                otazka_id: _otazka_id,
                hodnotitel_type: _user_type,
                prax_id: _prax_id
            }
            axios.post('/get-practices-eval-results-details', data, this.$store.getters.getAxiosConfig)
            .then((res) => {
                this.myDetail = res.data
                if (res.data.message != 'OK') {
                    this.$store.commit('setFeedback', res.data.message)
                } 
                this.showDetailIndex = _user_type+_index
            })
            .catch(error => {
                this.$store.commit('setFeedback', error.name+': '+error.message)
            })

        },
        closeprax(_index) {
            this.gototo(_index)
            this.showpraxIndex = -1
        },
        gototo(_id) {
            const myid = document.getElementById(_id);
            let position = myid.getBoundingClientRect()
            window.scrollTo(position.left, position.top + window.scrollY - 50);
        },
    }
}
</script>